import { apiClient } from '@/to-fsd/shared/api';

export const getNotifications = params => {
  return apiClient.get('/merchant/merchant/notifications', { params });
};
